import D1PEMBICARA1SESI1 from "../../assets/seminar/canggih.png";
import D1PEMBICARA2SESI1 from "../../assets/seminar/sutiaji.png";
import D1PEMBICARA3SESI1 from "../../assets/seminar/eko.png";
import D2PEMBICARA3SESI1 from "../../assets/seminar/orlando.png";
// import D1PEMBICARA1SESI2 from "../../assets/seminar/prayogo.png";
import D2PEMBICARA1SESI1 from "../../assets/seminar/tubagus.png";
import D2PEMBICARA1SESI2 from "../../assets/seminar/ojk.png";
import D2PEMBICARA3SESI3 from "../../assets/seminar/reinu.png";

export const seminarDay1Sesi1 = {
  title: "Sesi 1 : Malang MSME Development Strategy",
  description:
    "Mensosialisasikan dan mengedukasi masyarakat, serta mahasiswa Malang terhadap potensi ekonomi daerah terhadap pengembangan UMKM.",
  pemateri: [
    {
      image: D1PEMBICARA1SESI1,
      name: "Canggih Sakina Hans",
      position: "(Ketua Umum BPC HIPMI Kota Malang)",
    },
    {
      image: D1PEMBICARA2SESI1,
      name: "Drs. H. Sutiaji",
      position: "(Walikota Malang)",
    },
    {
      image: D1PEMBICARA3SESI1,
      name: "Dr. Eko S. Yuliadi, S.Sos., MM",
      position: "(Kepala Diskopindag Malang)",
    },
  ],
};

export const seminarDay1 = [
  {
    image: "",
    name: "",
    position: "",
    title:
      "Sesi 2 : How to Maintain Consistency in Business by Building Good Leadership",
    description:
      "Peserta dapat menemukan solusi dan inovasi bisnis dengan sistem kepemimpinan yang baik agar bisnis berjalan dengan konsisten.",
  },
  {
    image: D2PEMBICARA3SESI1,
    name: "Oraldo Emeraldi Anggoro",
    position: "(Founder & Content Creator @youngtrepreneur.id)",
    title: "Sesi 3 : How to Increase Brand Awareness in the Digital Era",
    description:
      "Peserta dapat meningkatkan brand awareness usahanya dengan memanfaatkan teknologi dalam bidang digital marketing.",
  },
];

export const seminarDay2 = [
  {
    image: D2PEMBICARA1SESI1,
    name: "Tubagus Syailendra",
    position: "(Chicken Executive Officer at Chickin Indonesia)",
    title:
      "Sesi 1 : Analyzing Competitive Strategies between Startup and Corporate in 5.0 Era",
    description:
      "Menganalisis cara menjalankan dan mengembangkan bisnis, serta memahami strategi perusahaan start-up dan coorporate.",
  },

  {
    image: D2PEMBICARA1SESI2,
    name: " OJK Malang",
    position: "",
    title: "Sesi 2 : Criteria for A Good Company to Invest In",
    description:
      "Peserta dan perintis usaha kecil dapat mengetahui kriteria perusahaan yang sesuai untuk dapat menarik investor.",
  },
  {
    image: D2PEMBICARA3SESI3,
    name: "Reinukky Abidharma",
    position: "(Owner Pesen Kopi)",
    title:
      "Sesi 3 : Youngpreneur's Creative Ways of Improving Business in Era 5.0",
    description:
      "Peserta khususnya mahasiswa dapat mengidentifikasi stategi yang tepat untuk diterapkan dalam bisnisnya agar berkembang.",
  },
];
